import { Outlet } from "react-router";
import Header from "../../../component/layout/header";
import useNav from "../../../script/tabingNavArray";

const TeamProjectsLayout = () => {
  const navList = useNav();
  let { teamprojectBottomNav, topProjectNav } = navList;
  return (
    <div className="webBody">
      <Header bottomTabs={teamprojectBottomNav} topTabs={topProjectNav} />
      <Outlet />
    </div>
  );
};

export default TeamProjectsLayout;
